import chatService from '../../api/chat'

const state = {
  messages: [],
  chat: {}
}

const mutations = {
  setMessages (state, messages) {
    state.messages = messages
  },
  setChat (state, chat) {
    state.chat = chat
  }
}

const actions = {
  getChatMessages ({ commit }, chatId) {
    chatService.getMessages(chatId).then(response => {
      commit('setMessages', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  sendMessage ({ commit }, message) {
    return new Promise((resolve, reject) => {
      chatService.sendMessage(message).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  resolveChat ({ commit }, session) {
    return new Promise((resolve, reject) => {
      chatService.resolveChat(session).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  startChat ({ commit }, session) {
    return new Promise((resolve, reject) => {
      chatService.startChat(session).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  reOpenChat ({ commit }, session) {
    return new Promise((resolve, reject) => {
      chatService.reOpenChat(session).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getChat ({ commit }, chatId) {
    chatService.getChat(chatId).then(response => {
      commit('setChat', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  resolveChatBySessionId ({ commit }, sessionId) {
    return new Promise((resolve, reject) => {
      chatService.resolveChatBySessionId(sessionId).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  moveChatToCM ({ commit }, session) {
    return new Promise((resolve, reject) => {
      chatService.moveChatToCM(session).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
